var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2367 5.05428C19.5295 4.39295 20.4679 4.39295 20.7607 5.05428L24.3877 13.2472C24.5087 13.5206 24.7669 13.7082 25.0644 13.7389L33.9771 14.6566C34.6966 14.7307 34.9866 15.6232 34.4481 16.106L27.7769 22.0873C27.5543 22.2868 27.4557 22.5904 27.5185 22.8827L29.3998 31.6429C29.5517 32.35 28.7925 32.9016 28.1669 32.5386L20.4169 28.0423C20.1583 27.8923 19.8391 27.8923 19.5805 28.0423L11.8305 32.5386C11.2049 32.9016 10.4457 32.35 10.5975 31.6429L12.4789 22.8827C12.5417 22.5904 12.4431 22.2868 12.2205 22.0873L5.54931 16.106C5.01082 15.6232 5.30082 14.7307 6.02025 14.6566L14.933 13.7389C15.2304 13.7082 15.4887 13.5206 15.6097 13.2472L19.2367 5.05428Z",
    fill: "#DFDFD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmpty);
export default __webpack_public_path__ + "static/media/starEmpty.662ca62a6eabaa5c4b6612b2e50f9702.svg";
export { ForwardRef as ReactComponent };